import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import ThemeContext from '../../contexts/ThemeContext';
import CalendarIcon from '../../images/CalendarIcon';
import { Field, FieldLabel, FieldValue } from './SummaryShared';
import i18n from '../../i18n';

const DateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SummaryDeliveryDate = ({ date }) => {
  const { colors } = useContext(ThemeContext);

  if (!date) return null;
  return (
    <Field>
      <FieldLabel>{i18n('translation_order_delivery_date')}</FieldLabel>
      <DateRow>
        <CalendarIcon color={colors.iconAccentColor} size={16} />
        <FieldValue>{moment(date).format('D.M.YYYY')}</FieldValue>
      </DateRow>
    </Field>
  );
};

SummaryDeliveryDate.propTypes = {
  date: PropTypes.instanceOf(Date),
};

export default SummaryDeliveryDate;
